/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash fb5834cf2d03b2e9bbc9b871a30a5e8a */

import { ConcreteRequest } from "relay-runtime";

export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type EditPersonalProfileInput = {
    userServiceId: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    email?: string | null | undefined;
    currency?: Currency | null | undefined;
    preferredLocale?: string | null | undefined;
    communicationPreferredLocale?: string | null | undefined;
    measurementUnit?: MeasurementUnit | null | undefined;
    zipCode?: string | null | undefined;
    shareActivities?: boolean | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type changeDisplayPreferrencesMutationVariables = {
    input: EditPersonalProfileInput;
};
export type changeDisplayPreferrencesMutationResponse = {
    readonly editPersonalProfile: {
        readonly user: {
            readonly preferences: {
                readonly currency: Currency | null;
                readonly preferredLocale: string | null;
            } | null;
        } | null;
    } | null;
};
export type changeDisplayPreferrencesMutation = {
    readonly response: changeDisplayPreferrencesMutationResponse;
    readonly variables: changeDisplayPreferrencesMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredLocale",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "changeDisplayPreferrencesMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EditPersonalProfilePayload",
                    "kind": "LinkedField",
                    "name": "editPersonalProfile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "changeDisplayPreferrencesMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EditPersonalProfilePayload",
                    "kind": "LinkedField",
                    "name": "editPersonalProfile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/changeDisplayPreferrencesMutation",
            "metadata": {},
            "name": "changeDisplayPreferrencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '9e922da30f972f8aa9108a9e2d005a70';
export default node;
